export enum sortType {
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
}
